/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export const environment = {
    production: false,
    showErrorsOnApp: false,
    baseUrl: '',
    specialOrdersBaseUrl: '/ms-specialorders',
    securityBaseUrl: '/ms-security',
    claimsBaseUrl: '/ms-claims',
    fileManagerBaseUrl: '/ms-filemanager',
    settingsBaseUrl: '/ms-settings',
    partNumberChangesBaseUrl: '/ms-partnumberchanges',
    maxClaimPositions: 99,
    settlementsBaseUrl: '/ms-settlements',
    bundlesBaseUrl: '/ms-bundles'
};
